import { Box, ButtonGroup, styled } from '@mui/material';
import FarmImport from 'FeatureModules/DataImport/Components/Views/FarmImport';
import GeoDataImport from 'FeatureModules/DataImport/Components/Views/GeoDataImport';
import { DATA_IMPORT_CATEGORY_CONFIG } from 'FeatureModules/DataImport/utils/dataImportConfig';
import usePageTitle from 'hooks/usePageTitle';
import { InfoTooltip, Tabs, ThemeButton } from 'DesignSystem';
import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { EAvailableSizes } from 'DesignSystem/types/size.types';
import { NumberParam, useQueryParam, withDefault } from 'use-query-params';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';
import { useQuery } from '@apollo/client';
import { GET_BASE_PARTNER_COMPANY } from 'graphql/secure/queries/partner.queries';

const Container = styled('div')(() => ({
  position: 'relative',
  minHeight: 50,
}));

const DataImports: FC = () => {
  usePageTitle('Origin data import');
  const { id: companyId } = useParams<{ id?: string }>();
  const [selectedTab, setSelectedTab] = useQueryParam<number>('tab', withDefault(NumberParam, 0), {
    removeDefaultsFromUrl: true,
  });

  const { data: partnerData } = useQuery(GET_BASE_PARTNER_COMPANY, {
    variables: { id: companyId },
    skip: !companyId,
  });

  const partner = partnerData?.partner;

  // Farm tab is the default tab
  const categoryConfig = DATA_IMPORT_CATEGORY_CONFIG[0];

  // Nothing, since only one tab exists for now
  const handleTabChange = () => undefined;

  return (
    <PageContainer>
      <PageTitle
        title="Origin data import"
        goBackUrl={companyId ? '/partners' : undefined}
        titleExtension={partner?.name}
        goBackLabel={companyId ? 'All partners' : undefined}
      />

      <Container>
        <Box mt={3} mb={2.5}>
          <Tabs
            tabs={DATA_IMPORT_CATEGORY_CONFIG.map(({ tab }) => tab)}
            selectedTab={categoryConfig.key}
            onChange={handleTabChange}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={1} mb={1.5}>
          <ButtonGroup>
            <ThemeButton
              className={selectedTab === 0 ? 'selected' : ''}
              onClick={() => setSelectedTab(0)}
              typographyColor="ALMOST_BLACK"
            >
              Advanced geo-data import
            </ThemeButton>
            <ThemeButton
              className={selectedTab === 1 ? 'selected' : ''}
              onClick={() => setSelectedTab(1)}
              typographyColor="ALMOST_BLACK"
            >
              Farm data import
            </ThemeButton>
          </ButtonGroup>
          <InfoTooltip
            size={EAvailableSizes.SMALL}
            text="Upload farm data by file upload or by manually adding information. For more flexibility and validation in uploading farm geo-data (supporting .geojson, .kml, .csv, or .xlsx files), use the advanced geo-data import. "
          />
        </Box>
      </Container>

      {selectedTab === 0 && <GeoDataImport />}
      {selectedTab === 1 && <FarmImport />}
    </PageContainer>
  );
};

export default DataImports;
